import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { m, AnimatePresence } from 'framer-motion';

export const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      const footerRect = footer?.getBoundingClientRect();
      const isFooterVisible = footerRect ? footerRect.top < window.innerHeight : false;
      if (window.scrollY > 300 && !isFooterVisible) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <m.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 p-3 bg-rs-bright text-white rounded-full shadow-[0_0_20px_rgba(231,10,53,0.5)] hover:shadow-[0_0_30px_rgba(231,10,53,0.8)] transition-all hover:scale-110"
          aria-label="Back to Top"
        >
          <ArrowUp size={24} />
        </m.button>
      )}
    </AnimatePresence>
  );
};
